import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';
import LayoutStyle from './Layout.module.scss';
import { getToken } from './common/common';
import { Navigate, useLocation } from 'react-router';
import React, { useEffect, useState } from 'react';
import Drawer from '@mui/material/Drawer';
import { useMediaQuery, useTheme } from '@mui/material';

export default function Layout(props) {
  const { component } = props;
  const [search, setSearch] = useState('');
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const location = useLocation();

  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isDesktop) {
      setMobileNavOpen(false);
    }
  }, [isDesktop]);

  if (getToken().error) {
    return <Navigate to={'/login'} />;
  }

  const enhancedComponent = React.cloneElement(component, { search });

  return (
    <div className={LayoutStyle.mainBox}>
      <div className={LayoutStyle.sidebarDesktop}>
        <Sidebar />
      </div>
      <Drawer
        anchor="left"
        open={mobileNavOpen}
        onClose={() => setMobileNavOpen(false)}
        variant="temporary"
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            width: 186,
            maxWidth: '86vw',
            boxSizing: 'border-box',
            borderRight: '1px solid var(--sidebar-border)',
            backgroundColor: 'var(--sidebar-bg)',
            overflowY: 'auto',
          },
        }}
      >
        <Sidebar onAfterNavigate={() => setMobileNavOpen(false)} />
      </Drawer>
      <div className={LayoutStyle.subMainBox}>
        <Header setSearch={setSearch} onOpenMobileNav={() => setMobileNavOpen(true)} />
        <div className={LayoutStyle.contentBox}>{enhancedComponent}</div>
      </div>
    </div>
  );
}
